
import turnkeyevcs from "../assets/images/PNG/turnkeyevcs.png";
import turnkey from "../assets/images/PNG/turnkey.png";
import substation from "../assets/images/PNG/substation.png";
import mnc from "../assets/images/PNG/mnc.png";
import site from "../assets/images/PNG/site.png";
import meter from "../assets/images/PNG/meter.png";
import ht_lt from "../assets/images/PNG/ht&lt.png";
import legal from "../assets/images/PNG/legal.png";
import court from "../assets/images/PNG/court.png";
import revenue from "../assets/images/PNG/revenue.png";
import ria from "../assets/images/PNG/ria.png";
import maintence from "../assets/images/PNG/maintence.png";
import evstation from "../assets/images/PNG/evstation.png";
import HTLT from "../pages/Service/htlt";
import TurnkeyEVCS from "../pages/Service/turnkeysevcs";
import Substation from "../pages/Service/substation";
import MNCVendor from "../pages/Service/mnc-vendor";
import SiteFeasibilityPage from "../pages/Service/site";
import PrecisionMeteringPage from "../pages/Service/precision-metering";
import TurnkeyProjectsPage from "../pages/Service/turnkey-projects";
import AdvocacyLegalPage from "../pages/Service/advocacy-legal";
import ElectricalLitigationPage from "../pages/Service/electrical-litigation";
import RevenueMattersPage from "../pages/Service/revenue-matters";
import RIAPage from "../pages/Service/ria-matters";
import EVCSMaintenancePage from "../pages/Service/evcs-maintenance";
import PrimeManagementPage from "../pages/Service/prime-management";

export const SERVICES_LIST = [
  {
      id: 1,
      title: "HT And LT Connectivity",
      icon: ht_lt,
      component: HTLT,
      desc: "Expert establishment of High Tension and Low Tension electrical network connections.",
      path: "/services/ht-and-lt-connectivity"
    },
    {
      id: 2,
      title: "Turnkey EVCS Deployment",
      icon: turnkeyevcs,
      component : TurnkeyEVCS,
      desc: "Full end-to-end charging station setup including civil and electrical construction.",
      path: "/services/turnkey-evcs-deployment"
    },
    {
      id: 3,
      title: "Substation Building",
      icon: substation,
      component : Substation,
      desc: "Full-scale construction and commissioning of dedicated electrical substations.",
      path: "/services/substation-building"
    },
    {
      id: 4,
      title: "MNC Vendor Specialist",
      icon: mnc,
      component: MNCVendor,
      desc: "Trusted tier-1 vendor management for multinational corporate infrastructure.",
      path: "/services/mnc-vendor"
    },
    {
      id: 5,
      title: "Site Feasibility Studies",
      icon: site,
      component : SiteFeasibilityPage,
      desc: "Detailed technical assessments and energy load analysis for new industrial or EVCS project sites",
      path:"/services/site-feasibility"
    },
    {
      id: 6,
      title: "Precision Metering",
      icon: meter,
      component : PrecisionMeteringPage,
      desc: "Smart commercial meter upgrades and installs for accurate energy tracking.",
      path : "/services/precision-metering"
    },
    {
      id: 7,
      title: "Turnkey Projects for CBG, CNG, & EV",
      icon: turnkey,
      component:TurnkeyProjectsPage,
      desc: "Comprehensive end-to-end deployment of Compressed Bio-Gas (CBG), Compressed Natural Gas (CNG), and Electric Vehicle (EV) infrastructure.",
      path:"/services/Turn-key-projects-for-ev-cbg-cng"
    },
    {
      id: 8,
      title: "Advocacy & Legal Advisory",
      icon: legal,
      component:AdvocacyLegalPage,
      desc: "Providing expert legal counsel and strategic representation for complex industrial and engineering projects.",
      path:"/services/advocacy-legal-advisory"
    },
    {
      id: 9,
      title: "Court Proceedings for Electrical Matters",
      icon: court,
      component: ElectricalLitigationPage,
      desc: "Specialized litigation and dispute resolution for high-voltage energy sector legalities.",
      path:"/services/electrical-litigation"
    },
    {
      id: 10,
      title: "Revenue Related Matters",
      icon: revenue,
      component:RevenueMattersPage,
      desc: "Assistance with utility billing disputes, tariff assessments, and financial regulatory compliance",
      path:"/services/reveneue-reated-matters"
    },
    {
      id: 11,
      title: "RIA(Rapid Inspection & Assessments)",
      icon: ria,
      component:RIAPage,
      desc: "Fast-track site audits, technical feasibility, and high-speed infrastructure safety evaluations",
      path:"/services/RIA"
    },
    {
      id: 12,
      title: "Maintaince work of EVCS",
      icon: maintence,
      component:EVCSMaintenancePage,
      desc: "Ongoing technical support, preventive care, and rapid repair services for charging networks.",
      path:"/services/EVCS-maintaince"
    },
    
    {
      id:13,
      title:"Proactive Restoration and Integrated Management of EV Stations",
      icon: evstation,
      component:PrimeManagementPage,
      desc:"Ensures maximum uptime for EV stations through real-time health monitoring and rapid-response technical interventions.",
      path:"/services/prime-management"
    }
  // Add your other services (Site Feasibility, Substation Building, etc.)
];